// This file is only a template for constants.  Copy and paste this to your application's constants .ts file and start off from there
// Rename all things with App_Name.
// Naming convention for constants is "[App Name]Constants.ts" i.e. UsersConstants.ts, EntitlementConstants.ts

// convention for constants is
// [App_Name]_[Action]
var UserProfileConstants: IUserProfileConstants = {
    PROFILE_DISPATCHER: 'PROFILE_DISPATCHER',
    PROFILE_GET: 'PROFILE_GET',
    PROFILE_GET_PASSWORD_SETTINGS: 'PROFILE_GET_PASSWORD_SETTINGS',
    PROFILE_UPDATE: 'PROFILE_UPDATE',
    PROFILE_UPDATE_PASSWORD: 'PROFILE_UPDATE_PASSWORD',
    PROFILE_UPDATE_PASSWORD_SUCCESS: 'PROFILE_UPDATE_PASSWORD_SUCCESS',
    PROFILE_MAIN_PAGE: 'PROFILE_MAIN_PAGE',
    PROFILE_UPDATE_PASSWORD_FORM: 'PROFILE_UPDATE_PASSWORD_FORM',
    PROFILE_VALIDATION_ERROR: 'PROFILE_VALIDATION_ERROR',
    PROFILE_UPDATE_OBJECT: 'PROFILE_UPDATE_OBJECT',
    PROFILE_CANCEL_CHANGES: 'PROFILE_CANCEL_CHANGES'
} as const;

export default UserProfileConstants;